module.exports = __webpack_public_path__ + "img/Dantam Bridal 03.9b126772.jpg";